import { render, staticRenderFns } from "./DealsSectionWithFilters.vue?vue&type=template&id=875c4db2&scoped=true&"
import script from "./DealsSectionWithFilters.vue?vue&type=script&lang=js&"
export * from "./DealsSectionWithFilters.vue?vue&type=script&lang=js&"
import style0 from "./DealsSectionWithFilters.vue?vue&type=style&index=0&id=875c4db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875c4db2",
  null
  
)

export default component.exports